import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage/HomePage';
import StudentsPage from './components/StudentsPage/StudentsPage';

const basePath = process.env.PUBLIC_URL;

const App = () => {
  return (
    <Router basename={basePath}>
      <Routes>
        <Route path="/students/*" element={<StudentsPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </Router>
  );
};

export default App;
